module.exports = __webpack_public_path__ + "static/media/mobile_preview.943894e5.png";